import React from 'react';
import { motion } from 'framer-motion';
export function BuiltDifferent() {
  const features = [{
    icon: '🌍',
    title: 'No Learning Curve',
    desc: 'Just talk. MR figures out the rest.'
  }, {
    icon: '🗣️',
    title: 'Fully Multilingual',
    desc: 'Any language. Mid-conversation. No setup.'
  }, {
    icon: '🗺️',
    title: 'Live Business Mind Map',
    desc: 'See your entire business in one living, breathing view.'
  }];
  return <>
      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-purple/20 to-transparent" data-id="element-98" data-mp="2icpz0fzz2vev" />

      <section className="py-16 px-6 bg-white" data-id="element-99" data-mp="2nahsheg9mpl6">
        <div className="inner-container" data-id="element-100" data-mp="2sadvpbh52czo">
          <div className="text-center mb-10" data-id="element-101" data-mp="2sb5fzq5acoan">
            <span className="text-purple text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-102" data-mp="2s8174fgvl4dn">
              Built Different
            </span>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-103" data-mp="7ilinr54prr6">
            {features.map((feat, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-gradient-to-r from-purple/10 to-teal/10 border border-gray-200 rounded-full py-4 px-8 flex items-center gap-4 shadow-sm hover:shadow-md hover:border-purple/30 transition-all" data-id="element-104" data-mp="1ghujj30dxecv" data-mpi={i}>
                <span className="text-2xl" data-id="element-105" data-mp="js3p13s3fr72">{feat.icon}</span>
                <div data-id="element-106" data-mp="jtokqwq59g6i">
                  <h3 className="font-poppins font-semibold text-sm text-gray-900" data-id="element-107" data-mp="jq0r7xkp8trs">
                    {feat.title}
                  </h3>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-108" data-mp="9te7xd80uarv">{feat.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-teal/20 to-transparent" data-id="element-109" data-mp="56g1d8mom4jg" />
    </>;
}